import CageWeightDistributionContainer from './CageWeightDistributionContainer';
import { WeightDistributionProvider } from './cage-weight-distribution-context';

/**
 * Mounts the distribution provider around the page, so the container can read
 * the reduced state through the hooks rather than threading it down.
 */
export default function CageWeightDistributionProviderContainer() {
    return (
        <WeightDistributionProvider>
            <CageWeightDistributionContainer />
        </WeightDistributionProvider>
    );
}
